import { render, staticRenderFns } from "./List.vue?vue&type=template&id=1064532e&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&id=1064532e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1064532e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/nantong-hrpark-prod-mobile-property(微信公众号-物业）/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1064532e', component.options)
    } else {
      api.reload('1064532e', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=1064532e&scoped=true&", function () {
      api.rerender('1064532e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/park/dynamic/List.vue"
export default component.exports